module.exports = new __parcel__URL__("battleroyale_evades_button.aa38fa5e.png").toString();